export default __webpack_public_path__ + "static/media/Contact.e2389d34.webp";